__webpack_public_path__ = "https://clients.ekos.bz.it/";

import "whatwg-fetch";
import Vue from "vue";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import { store } from "./store";

Vue.config.productionTip = false;

Vue.use(VueI18n);

const messages = {
  de: {
    title: "ÖLABSCHEIDER WARTUNGSHANDBUCH",
    logout_label: "Abmelden",
    login: {
      customer_number_label: "KUNDENNUMMER",
      password_label: "PASSWORT",
      login_label: "ANMELDEN",
      slogan_title: "INNOVATIVES DENKEN",
      slogan_text: `
      Seit Jahren übernehmen wir Ihre Sorgen in Bezug auf Ihren Ölabscheider. Im Rahmen eines Wartungsvertrages führen wir die Ölabscheiderwartungen durch. Die gesamte Dokumentation, wie Wartungsberichte, Entsorgungsnachweise, Analysezertifikate, Dichtheitsprüfungsprotokolle und sonstige notwendige Unterlagen können Sie ONLINE mit folgenden Vorteilen abrufen:<br><br>
      > Jederzeit Zugriff auf die Dokumente Ihres Ölabscheiders<br>
      > Keine mühevolle Suche bei einer Kontrolle<br>
      > Die Daten sind jederzeit auf dem neuesten Stand<br>
      > Sie können Ihre Dokumente beliebig oft anschauen, ausdrucken und wenn notwendig ablegen
      `,
      error: "Fehler beim Login. Bitte die Daten überpfüfen.",
    },
    dashboard: {
      navigation: {
        control_book_label: "KONTROLLBUCH",
        documents_label: "DOKUMENTE",
      },
      location_label: "Standort",
      no_files_found: "Keine Einträge vorhanden.",
      save_label: "Speichern",
      cancel_label: "Abbrechen",
      delete_label: "Löschen",
      reset_password_label: "Passwort zurücksetzen",
      new_user_label: "Neuer Benutzer",
      customer_data: {
        number_label: "Kundennummer",
        email_label: "eMail",
        name_label: "Kundenname",
        address_label: "Adresse",
      },
    },
  },
  it: {
    title: "LIBRETTO DI MANUTENZIONE - SEPARATORE D'OLIO",
    logout_label: "Disconnettersi",
    login: {
      customer_number_label: "CODICE CLIENTE",
      password_label: "PASSWORD",
      login_label: "ACCEDI",
      slogan_title: "PENSARE IN MODO INNOVATIVO",
      slogan_text: `
      Da anni ci siamo occupati delle vostre preoccupazioni riguardo al vostro separatore d'olio.Nell'ambito di un contratto di manutenzione eseguiamo la manutenzione del separatore d'olio e l'intera procedura, così come la pulizia e gli altri documenti necessari, è possibile richiamare ONLINE con i seguenti vantaggi<br><br>
      > Accesso ai documenti del separatore d'olio in qualsiasi momento<br>
      > Niente più ricerche noiose durante un controllo<br>
      > I dati sono sempre aggiornati<br>
      > È possibile visualizzare, stampare e archiviare i documenti tutte le volte che si desidera
      `,
      error: "Errore durante l'accesso. Per favore controllare i dati.",
    },
    dashboard: {
      navigation: {
        control_book_label: "LIBRO DI CONTROLLO",
        documents_label: "DOCUMENTI",
      },
      location_label: "Luogo",
      no_files_found: "Nessun file trovato.",
      save_label: "Salva",
      cancel_label: "Cancella",
      delete_label: "Rimuovi",
      reset_password_label: "Reimpostare la password",
      new_user_label: "Nuovo utente",
      customer_data: {
        number_label: "Numero cliente",
        email_label: "eMail",
        name_label: "Nome",
        address_label: "Indirizzo",
      },
    },
  },
};

const i18n = new VueI18n({
  messages,
  locale: "de",
});

// create portal to global window
Vue.prototype.window = window;

// custom fetch method (to handle for example JWT refresh tokens)
Vue.prototype.$fetch = async function (
  input: RequestInfo,
  init?: RequestInit,
): Promise<Response> {
  try {
    if (typeof input === "string" && input.startsWith("/api/")) {
      input = store.apiUrl + input;

      if (init) init.credentials = "include";
      else init = { credentials: "include" };
    }

    let result = await fetch(input, init);

    // If the user is not authorized, first try to request a new access token
    if (
      typeof input === "string" &&
      input !== "/api/users/login" &&
      result.status === 401
    ) {
      await fetch(store.apiUrl + "/api/users/token", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    } else {
      return result;
    }

    result = await fetch(input, init);

    // If the authentication fails again, redirect the user to the login
    if (result.status === 401) {
      store.currentComponent = "login";
    }

    return result;
  } catch (error) {
    throw error;
  }
};

Vue.component("ekos-login-area", {
  i18n,
  props: ["language"],
  beforeMount() {
    this.$i18n.locale = this.$props["language"];
  },
  render: (h) => h(App),
});
